// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductFacetList":"ef_a bhl_g","ProductFacetList__pill":"ef_b"};